import {
  Header,
  StatusIndicator,
  Table,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import StorageImage from './storageImage';

function FeedbackSummaryTable({
  header = <Header>Feedback</Header>,
  feedback = [],
  optionalFeedback = [],
  forceEmpty = false,
  empty = null,
}) {
  const items = useMemo(
    () => [...feedback, ...optionalFeedback].map((item) => ({
      ...item,
      image: (item.image ? (
        <ErrorBoundary fallback={<StatusIndicator type="error">Error loading image</StatusIndicator>}>
          <StorageImage storagePath={item.image} alt={item.title} style={{ maxWidth: '100px' }} />
        </ErrorBoundary>
      ) : null),
    })),
    [feedback, optionalFeedback],
  );
  return (
    <Table
      header={header}
      items={forceEmpty ? [] : items}
      empty={empty}
      columnDefinitions={[
        {
          id: 'title',
          header: 'Title',
          cell: (item) => item.title,
        },
        {
          id: 'text',
          header: 'Text',
          // eslint-disable-next-line react/no-unstable-nested-components
          cell: (item) => <span style={{ whiteSpace: 'normal' }}>{item.text}</span>,
          maxWidth: '300px',
        },
        {
          id: 'image',
          header: 'Image',
          cell: (item) => item.image,
          maxWidth: '200px',
        },
        {
          id: 'checkboxText',
          header: 'Checkbox Text',
          // eslint-disable-next-line react/no-unstable-nested-components
          cell: (item) => item.checkboxText || <span style={{ fontStyle: 'italic' }}>Accept changes</span>,
        },
        {
          id: 'category',
          header: 'Category',
          cell: (item) => item.category,
        },
      ]}
    />
  );
}

FeedbackSummaryTable.propTypes = {
  header: PropTypes.node,
  feedback: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.string,
    checkboxText: PropTypes.string,
    category: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  })),
  optionalFeedback: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.string,
    checkboxText: PropTypes.string,
    category: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  })),
  forceEmpty: PropTypes.bool,
  empty: PropTypes.node,
};

export default FeedbackSummaryTable;
